// 模擬 CSS auto-placement，回傳每個 item 加上 x/y 的陣列
// 從 admin 的 GalleryMosaicUnit.jsx 抽出（前端不需要編輯邏輯，只需要這個純函式）
const COLS = 3

export function calcPositions(items) {
  const occupied = new Set()
  const isFree = (x, y) => !occupied.has(`${x},${y}`)
  return items.map(item => {
    const w = item.colSpan ?? 1
    const h = item.rowSpan ?? 1
    for (let r = 0; r < 99; r++) {
      for (let c = 0; c + w <= COLS; c++) {
        let ok = true
        check: for (let dr = 0; dr < h; dr++)
          for (let dc = 0; dc < w; dc++)
            if (!isFree(c + dc, r + dr)) { ok = false; break check }
        if (ok) {
          for (let dr = 0; dr < h; dr++)
            for (let dc = 0; dc < w; dc++)
              occupied.add(`${c + dc},${r + dr}`)
          return { ...item, x: c, y: r }
        }
      }
    }
    return item
  })
}
